import React from "react";
import GameList from "../../../components/GameList/GameList";

export default function FilteredGames({ games }) {
  return <GameList games={[...games]} />;
}
